import type { APIResponse } from '../../../types/api';

export type Term = {
  id: number;
  publishedAt: string;
  term: string;
};

/**
 * 規約タイプ（`oem_terms.category` = API の OEM_TERM_CATEGORY）。
 * 値は API 側の `config/constants.php` の定義と一致させる。
 */
export const TERM_CATEGORY = {
  term: 'term',
  pp: 'pp',
  tradelaw: 'tradelaw',
  paymentlaw: 'paymentlaw',
  oemSubscriptionTerm: 'oem_subscription_term',
  artistSubscriptionTerm: 'artist_subscription_term',
} as const;

export type TermCategory = (typeof TERM_CATEGORY)[keyof typeof TERM_CATEGORY];

/** 再承諾が必要な規約1件（現行公開版） */
export type PendingReconsentTerm = {
  category: TermCategory;
  /** 同意ログに記録する版ID */
  oemTermId: number;
  /** 管理画面で登録された規約本文（HTML） */
  term: string;
};

/** `GET /user/v1/term-consent/pending` の result */
export type GetTermConsentPendingResult = {
  /** 同意が必要な規約タイプの配列。空＝同意不要 */
  categories: TermCategory[];
  /** 各タイプの現行版情報。モーダル表示に使う。キー名は API のレスポンスに合わせる */
  documents: PendingReconsentTerm[];
};

export type GetTermConsentPendingResponse = APIResponse<GetTermConsentPendingResult>;

export type PostTermConsentParams = {
  /** 同意した規約版のID配列 */
  oemTermIds: number[];
};

export type PostTermConsentResponse = APIResponse<null>;
